import { base_url, api_key } from '../config/config_api';
import { firestore } from './../firebase-config';

export const uploadImagem = async (id_revenda, file, tipo = "default") => {

  var upload_preset = "default";

  return firestore.collection("revenda").doc(id_revenda)
    .get()
    .then(doc => {

      var tipo_moldura = "personalizada";
      var diretorio = null;
      var imagem_moldura = null;

      if (doc.exists) {

        var revenda = doc.data();
        if(tipo == "transformation"){

          upload_preset = revenda.transformation === null || revenda.transformation === undefined || revenda.transformation === "" ? "default" : revenda.transformation;
          tipo_moldura  = revenda.tipo_moldura_veiculo === null || revenda.tipo_moldura_veiculo === undefined || revenda.tipo_moldura_veiculo === "" ? "personalizada" : revenda.tipo_moldura_veiculo;

          if(tipo_moldura == "imagem_rodape"){
            diretorio = revenda.diretorio_veiculo === null || revenda.diretorio_veiculo === undefined || revenda.diretorio_veiculo === "" ? null : revenda.diretorio_veiculo;;
            imagem_moldura = revenda.imagem_moldura_veiculo === null || revenda.imagem_moldura_veiculo === undefined || revenda.imagem_moldura_veiculo === "" ? null : revenda.imagem_moldura_veiculo;
          }

        }
        if(tipo == "transformation_vendidos"){

          upload_preset = revenda.transformation_vendidos === null || revenda.transformation_vendidos === undefined || revenda.transformation_vendidos === "" ? "default" : revenda.transformation_vendidos;
          tipo_moldura  = revenda.tipo_moldura_vendido === null || revenda.tipo_moldura_vendido === undefined || revenda.tipo_moldura_vendido === "" ? "personalizada" : revenda.tipo_moldura_vendido;

          if(tipo_moldura == "imagem_rodape"){
            diretorio = revenda.diretorio_vendido === null || revenda.diretorio_vendido === undefined || revenda.diretorio_vendido === "" ? null : revenda.diretorio_vendido;;
            imagem_moldura = revenda.imagem_moldura_vendido === null || revenda.imagem_moldura_vendido === undefined || revenda.imagem_moldura_vendido === "" ? null : revenda.imagem_moldura_vendido;
          }

        }

        let body_post = {
          "api_key": api_key,
          "id_revenda": id_revenda,
          "upload_preset": upload_preset,
          "file": file,
          "tipo_moldura": tipo_moldura,
          "diretorio": diretorio,
          "imagem_moldura": imagem_moldura,
        };

        return fetch(base_url+"/api/file/upload-imagem-moldura", { 
          method: "POST", 
          headers: { 
            'Content-Type': 'application/json'
          }, 
          body: JSON.stringify(body_post)
        })
        .then(response => {
          return response.json()
          .then(data => {
            if(data.status === 'success'){
              return {
                status: "success",
                data: data.data
              };            
            }else{
              return {
                status: "error",
                data: data.data
              };
            }
          })
          .catch(error => {
            return {
              status: "error",
              data: error
            };
          });
        })
        .catch(error => {
          return {
            status: "error",
            data: error
          };
        });

      }

      return {
        status: "error",
        data: "Erro ao obter revenda."
      };

    }).catch(function(error) {
      return {
        status: "error",
        data: error
      };
    });     

}